import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  margin-top: 20px;
`

export const TopInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`
